import {Injectable} from "@angular/core";
import {HttpBaseService} from "@tva/ng-migration/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {schoolwork12} from "@tva/ng-migration/common/util";

@Injectable({
    providedIn: "root",
})
export class CreSummaryService extends HttpBaseService{

    constructor(client: HttpClient) {
        super(client);
    }

    public getCreSummary(schoolId, studentId): Observable<any> {
        return this.get(schoolwork12.app.student.endpoints.creSummary(schoolId, studentId));
    }

    public getGradPlan(studentId, schoolId): Observable<any> {
        return this.get(`/student/${studentId}/gradplan/school/${schoolId}`);
    }

    public getOverrideCourses(studentId, schoolId, requirementId): Observable<any> {
        return this.get(`/student/${studentId}/school/${schoolId}/creTracking/override/pathwayRequirementsGroup/${requirementId}`);
    }

    public updateOverrideCourses(studentId, schoolId, data): Observable<any> {
      return this.post(`/student/${studentId}/school/${schoolId}/creTracking/coursesOverride/`, data);
    }

}
